var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ul", { staticClass: "ct-menu-nav" }, [
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "d-flex",
            attrs: { to: { name: "portal.dashboard" } },
          },
          [
            _c("img", {
              attrs: { src: require("../images/icons/menu.svg"), alt: "" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v(_vm._s(_vm.$t("dashboard.title"))),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "d-flex",
            attrs: {
              to: {
                name: _vm.$auth.check() ? "portal.profile" : "portal.login",
              },
            },
          },
          [
            _c("img", {
              attrs: { src: require("../images/icons/profile.svg"), alt: "" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v(
                _vm._s(
                  _vm.$auth.check()
                    ? _vm.$t("auth.profile")
                    : _vm.$t("auth.login")
                )
              ),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.$auth.check("ACL_00007")
      ? _c(
          "li",
          [
            _c("router-link", { attrs: { to: { name: "backoffice.home" } } }, [
              _c("img", {
                attrs: {
                  src: require("../images/icons/settings.svg"),
                  alt: "",
                },
              }),
              _vm._v(" "),
              _c("span", { staticClass: "label" }, [
                _vm._v(_vm._s(_vm.$t("backoffice.title"))),
              ]),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "li",
      [
        _c(
          "router-link",
          { staticClass: "d-flex", attrs: { to: { name: "portal.about" } } },
          [
            _c("img", {
              attrs: { src: require("../images/icons/glasses.svg"), alt: "" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [
              _vm._v("Sobre o cityhub.pt"),
            ]),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "li",
      [
        _c(
          "router-link",
          {
            staticClass: "d-flex",
            attrs: { to: { name: "portal.contact-us" } },
          },
          [
            _c("img", {
              attrs: { src: require("../images/icons/contact.svg"), alt: "" },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "label" }, [_vm._v("Contatos")]),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }